import { render, staticRenderFns } from "./personInfoCopy.vue?vue&type=template&id=6697836c&scoped=true&"
import script from "./personInfoCopy.vue?vue&type=script&lang=js&"
export * from "./personInfoCopy.vue?vue&type=script&lang=js&"
import style0 from "./personInfoCopy.vue?vue&type=style&index=0&id=6697836c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6697836c",
  null
  
)

export default component.exports